import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { INav, INavAction } from "../interfaces/INav";

const initialState: INav = {
  currentNav: "",
  navHistory: [],
  currentNavCategory: null,
};

const navSlice = createSlice({
  name: "nav",
  initialState: initialState,
  reducers: {
    updateNav: (state, action: PayloadAction<INavAction>) => {
      state.currentNav !== "" &&
        state.navHistory[state.navHistory.length - 1] !==
          action.payload.currentNav &&
        state.navHistory.push(state.currentNav);
      state.currentNav = action.payload.currentNav;
      state.currentNavCategory = action.payload.currentNavCategory;
    },
    goBack: (state) => {
      state.navHistory.pop();
    },
  },
  extraReducers: () => {},
});

export const { updateNav, goBack } = navSlice.actions;
export default navSlice.reducer;
